module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("微信公众账号消息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-093a12d0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/message-blocks/weChatMessage.vue
// module id = 6xkd
// module chunks = 0